import jsPDF from "jspdf";
import "jspdf-autotable";

const generatePDF = (tableRows, columns, title1, title, period) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  // Header
  const inboxTextWidth = doc.getTextWidth("Inmate Inbox");
  const historyTextWidth = doc.getTextWidth("Purchase History");
  const inboxX = (pageWidth - inboxTextWidth) / 2;
  const historyX = (pageWidth - historyTextWidth) / 2;

  // Header

  doc.setFontSize(12);
  doc.setFont("Helvetica", "");
  doc.text("Inmate Inbox", inboxX, 14);

  doc.setFontSize(18);
  doc.setFont("Times", "bold");
  doc.text("Purchase History", historyX, 24);

  // User Info
  const infoStartY = 40;
  doc.setFontSize(12);

  // Side headings
  doc.setFont("Helvetica", "bold");
  doc.setTextColor(255, 165, 0);
  doc.text("Name:", 17, infoStartY);
  doc.text("Resident ID:", 17, infoStartY + 8);
  doc.text("Facility:", 17, infoStartY + 16);

  // Values
  doc.setFont("Helvetica", "bold");
  doc.setTextColor(255, 165, 0);
  doc.text(String(tableRows[0]?.PublicUserName || ""), 80, infoStartY);
  doc.text(String(tableRows[0]?.InmateResidentId || ""), 80, infoStartY + 8);
  doc.text(String(tableRows[0]?.FacilityName || ""), 80, infoStartY + 16);

  if (period) {
    doc.setFont("Helvetica", "bold");
    doc.setTextColor(255, 165, 0); // Orange for heading
    doc.text("Date:", 17, infoStartY + 24);

    doc.setFont("Helvetica", "bold");
    doc.setTextColor(255, 165, 0); // Yellow for value
    doc.text(String(period), 80, infoStartY + 24); // Convert to string
  }

  // Separator Line
  doc.setLineWidth(0.5);
  doc.line(10, infoStartY + 32, pageWidth - 10, infoStartY + 32);

  // Add Watermark
  const addWatermark = () => {
    doc.setFontSize(64);
    doc.setTextColor(245, 245, 245); // Light gray for watermark
    doc.text("Inmate Inbox", pageWidth / 2, 190, {
      align: "center",
      angle: 45,
    });
  };
  addWatermark();

  // Transactions Section
  let startY = infoStartY + 40; // Adjust starting Y position
  tableRows.forEach((transaction, index) => {
    if (startY > 270) {
      doc.addPage();
      addWatermark();
      startY = 20;
    }

    const debitAmount =
      transaction.DebitAmount !== undefined ? transaction.DebitAmount : 0;
    const creditAmount =
      transaction.CreditAmount !== undefined ? transaction.CreditAmount : 0;

    const isCredit = creditAmount > 0 && debitAmount === 0;
    const isDebit = debitAmount > 0 && creditAmount === 0;

    const amount = isCredit ? creditAmount : debitAmount;

    doc.setFontSize(12);
    doc.setFont("Times", "bold");
    doc.setTextColor(0, 0, 0); // Black for side headings
    doc.text(`${isCredit ? "Credit" : "Debit"} Amount:`, 10, startY);

    doc.setFont("Helvetica", "bold");
    doc.setTextColor(isCredit ? 0 : 255, isCredit ? 128 : 0, 0); // Green for credit, red for debit
    doc.text(`$${String(amount.toFixed(2))}`, 50, startY); // Convert to string

    startY += 6;
    doc.setFont("Times", "bold");
    doc.setTextColor(0, 0, 0); // Black for side headings
    doc.text("Purpose:", 10, startY);

    doc.setFont("Helvetica", "normal");
    doc.setTextColor(0, 0, 0); // Black for values
    doc.text(String(transaction.TransactionPurpose || ""), 50, startY); // Convert to string

    if (transaction.PurchaseOrderID) {
      startY += 6;
      doc.setFont("Times", "bold");
      doc.text("Transaction ID:", 10, startY);

      doc.setFont("Helvetica", "normal");
      doc.text(String(transaction.POTransactionRandomID || ""), 50, startY); // Convert to string
    }

    startY += 6;
    doc.setFont("Times", "bold");
    doc.text("Transaction Date:", 10, startY);

    doc.setFont("Helvetica", "normal");
    doc.text(String(transaction.TransactionDate || ""), 50, startY); // Convert to string

    startY += 8;
    doc.setLineWidth(0.2);
    doc.line(10, startY, pageWidth - 10, startY);

    startY += 5;
  });

  // Add Page Numbers
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(10);
    doc.setFont("Helvetica", "normal");
    const pageNumberText = `Page ${i} of ${totalPages}`;

    doc.text(pageNumberText, pageWidth - 60, 10);
    doc.text(
      pageNumberText,
      pageWidth - 60,
      doc.internal.pageSize.getHeight() - 10
    );
  }
  // Save the PDF
  doc.save(`${tableRows[0]?.InmateFullName}.pdf`);
};

export default generatePDF;
